import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Scale } from 'lucide-react';
import type { ManagerIntelligenceStats } from '@/hooks/useManagerIntelligenceStats';

interface Props { stats: ManagerIntelligenceStats | null | undefined; isSelfView: boolean; }

export function ManagerLoadManagement({ stats }: Props) {
  const formatRate = (r: number | null) => r != null ? `${Math.round(r * 100)}%` : '—';
  
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2"><Scale className="h-5 w-5" />Load Management</CardTitle>
          <Badge variant="secondary">Catalyst</Badge>
        </div>
        <CardDescription>OBLI stewardship and workload balancing effectiveness</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-3 bg-muted/30 rounded-lg text-center">
          <div className="text-2xl font-bold">{formatRate(stats?.highLoadResponseScore)}</div>
          <div className="text-xs text-muted-foreground">High Load Response</div>
        </div>
        <div className="p-3 bg-muted/30 rounded-lg text-center">
          <div className="text-2xl font-bold">{formatRate(stats?.balanceEffectiveness)}</div>
          <div className="text-xs text-muted-foreground">Balance Effectiveness</div>
        </div>
        <div className="p-3 bg-muted/30 rounded-lg text-center">
          <div className="text-2xl font-bold">{formatRate(stats?.rolloverTrend)}</div>
          <div className="text-xs text-muted-foreground">Rollover Trend</div>
        </div>
      </CardContent>
    </Card>
  );
}
